import React from 'react';
import { shallowEqual } from "react-redux";
import Button from "./layout/Button";
import Spacer from "./layout/Spacer";
import PropertyGroup from "./properties/PropertyGroup";
import TextProperty from "./properties/TextProperty";
import useCurrentStep from './reactUtils/useCurrentStep';
import store from "../state/store";
import config from "../config";
import { useTypedSelector } from "../state/hooks";

export default function CrashReportView()
{
	const currentStep = useCurrentStep();

	const crashError = useTypedSelector(state => state.applicationModule.crashError, shallowEqual);

	function compileErrorDetails()
	{
		// note: can dump entire redux in here in the future
		const output = {
			projectName: currentStep.name,
			projectId: currentStep.id,
			date: new Date(),
			reporter: store.getState().userModule.sessionInfo!.email,
			errorMessage: crashError,
			actionStack: new Array<string>(),
		};

		for (const actionData of store.getState().historyModule.actionHistory)
		{
			output.actionStack.push(actionData.name);
		}

		return JSON.stringify(output, null, 2);
	}

	function sendErrorReport()
	{
		console.log("clicked link!");

		const link = "mailto:support@scopear.com"
			+ "?subject=" + encodeURIComponent(`WorkLink Create ${config.CREATE_VERSION} Crash Error: "${crashError}"`)
			+ "&body=" + encodeURIComponent(compileErrorDetails())
			;

		window.open(link, "_blank");
	}

	return (
		<div className={"screenCover dark centerContent vertical"}>
			<div>
				<h1 className="hugeText">Oops, something went wrong...</h1>
				<p>
					Unfortunately, we will have to revert to the last save state. You can do so by refreshing the page.
				</p>
				<p>
					<span className={"urlText"} onClick={() => sendErrorReport()}>Please send us the error log</span> to help us prevent this from happening again.
				</p>
				<PropertyGroup title={"Error Information"}
					expanded={false}
				>
					<p>You can review the error details below:</p>
					<TextProperty
						data-name={"error-content"}
						readonly={true}
						label={"Details"}
						value={compileErrorDetails()}
						rows={8}
					/>
				</PropertyGroup>
			</div>
			<Spacer size={{ y: "12px" }}/>
			<Button
				label={"Send Report & Continue"}
				onClick={() =>
				{
					sendErrorReport();
					window.location.reload();
				}}
			/>
		</div>
	);
}